"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: babylon/epoching/v1/tx.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgServiceName = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.MsgWrappedStakingUpdateParamsResponse = exports.MsgWrappedStakingUpdateParams = exports.MsgWrappedEditValidatorResponse = exports.MsgWrappedEditValidator = exports.MsgWrappedCancelUnbondingDelegationResponse = exports.MsgWrappedCancelUnbondingDelegation = exports.MsgWrappedBeginRedelegateResponse = exports.MsgWrappedBeginRedelegate = exports.MsgWrappedUndelegateResponse = exports.MsgWrappedUndelegate = exports.MsgWrappedDelegateResponse = exports.MsgWrappedDelegate = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const tx_1 = require("../../../cosmos/staking/v1beta1/tx");
const params_1 = require("./params");
exports.protobufPackage = "babylon.epoching.v1";
function createBaseMsgWrappedDelegate() {
    return { msg: undefined };
}
exports.MsgWrappedDelegate = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.msg !== undefined) {
            tx_1.MsgDelegate.encode(message.msg, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedDelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.msg = tx_1.MsgDelegate.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { msg: isSet(object.msg) ? tx_1.MsgDelegate.fromJSON(object.msg) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.msg !== undefined) {
            obj.msg = tx_1.MsgDelegate.toJSON(message.msg);
        }
        return obj;
    },
    create(base) {
        return exports.MsgWrappedDelegate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgWrappedDelegate();
        message.msg = (object.msg !== undefined && object.msg !== null) ? tx_1.MsgDelegate.fromPartial(object.msg) : undefined;
        return message;
    },
};
function createBaseMsgWrappedDelegateResponse() {
    return {};
}
exports.MsgWrappedDelegateResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedDelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.MsgWrappedDelegateResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseMsgWrappedDelegateResponse();
        return message;
    },
};
function createBaseMsgWrappedUndelegate() {
    return { msg: undefined };
}
exports.MsgWrappedUndelegate = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.msg !== undefined) {
            tx_1.MsgUndelegate.encode(message.msg, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedUndelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.msg = tx_1.MsgUndelegate.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { msg: isSet(object.msg) ? tx_1.MsgUndelegate.fromJSON(object.msg) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.msg !== undefined) {
            obj.msg = tx_1.MsgUndelegate.toJSON(message.msg);
        }
        return obj;
    },
    create(base) {
        return exports.MsgWrappedUndelegate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgWrappedUndelegate();
        message.msg = (object.msg !== undefined && object.msg !== null) ? tx_1.MsgUndelegate.fromPartial(object.msg) : undefined;
        return message;
    },
};
function createBaseMsgWrappedUndelegateResponse() {
    return {};
}
exports.MsgWrappedUndelegateResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedUndelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.MsgWrappedUndelegateResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseMsgWrappedUndelegateResponse();
        return message;
    },
};
function createBaseMsgWrappedBeginRedelegate() {
    return { msg: undefined };
}
exports.MsgWrappedBeginRedelegate = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.msg !== undefined) {
            tx_1.MsgBeginRedelegate.encode(message.msg, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedBeginRedelegate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.msg = tx_1.MsgBeginRedelegate.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { msg: isSet(object.msg) ? tx_1.MsgBeginRedelegate.fromJSON(object.msg) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.msg !== undefined) {
            obj.msg = tx_1.MsgBeginRedelegate.toJSON(message.msg);
        }
        return obj;
    },
    create(base) {
        return exports.MsgWrappedBeginRedelegate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgWrappedBeginRedelegate();
        message.msg = (object.msg !== undefined && object.msg !== null)
            ? tx_1.MsgBeginRedelegate.fromPartial(object.msg)
            : undefined;
        return message;
    },
};
function createBaseMsgWrappedBeginRedelegateResponse() {
    return {};
}
exports.MsgWrappedBeginRedelegateResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedBeginRedelegateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.MsgWrappedBeginRedelegateResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseMsgWrappedBeginRedelegateResponse();
        return message;
    },
};
function createBaseMsgWrappedCancelUnbondingDelegation() {
    return { msg: undefined };
}
exports.MsgWrappedCancelUnbondingDelegation = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.msg !== undefined) {
            tx_1.MsgCancelUnbondingDelegation.encode(message.msg, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedCancelUnbondingDelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.msg = tx_1.MsgCancelUnbondingDelegation.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { msg: isSet(object.msg) ? tx_1.MsgCancelUnbondingDelegation.fromJSON(object.msg) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.msg !== undefined) {
            obj.msg = tx_1.MsgCancelUnbondingDelegation.toJSON(message.msg);
        }
        return obj;
    },
    create(base) {
        return exports.MsgWrappedCancelUnbondingDelegation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgWrappedCancelUnbondingDelegation();
        message.msg = (object.msg !== undefined && object.msg !== null)
            ? tx_1.MsgCancelUnbondingDelegation.fromPartial(object.msg)
            : undefined;
        return message;
    },
};
function createBaseMsgWrappedCancelUnbondingDelegationResponse() {
    return {};
}
exports.MsgWrappedCancelUnbondingDelegationResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedCancelUnbondingDelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.MsgWrappedCancelUnbondingDelegationResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseMsgWrappedCancelUnbondingDelegationResponse();
        return message;
    },
};
function createBaseMsgWrappedEditValidator() {
    return { msg: undefined };
}
exports.MsgWrappedEditValidator = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.msg !== undefined) {
            tx_1.MsgEditValidator.encode(message.msg, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedEditValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.msg = tx_1.MsgEditValidator.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { msg: isSet(object.msg) ? tx_1.MsgEditValidator.fromJSON(object.msg) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.msg !== undefined) {
            obj.msg = tx_1.MsgEditValidator.toJSON(message.msg);
        }
        return obj;
    },
    create(base) {
        return exports.MsgWrappedEditValidator.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgWrappedEditValidator();
        message.msg = (object.msg !== undefined && object.msg !== null)
            ? tx_1.MsgEditValidator.fromPartial(object.msg)
            : undefined;
        return message;
    },
};
function createBaseMsgWrappedEditValidatorResponse() {
    return {};
}
exports.MsgWrappedEditValidatorResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedEditValidatorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.MsgWrappedEditValidatorResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseMsgWrappedEditValidatorResponse();
        return message;
    },
};
function createBaseMsgWrappedStakingUpdateParams() {
    return { msg: undefined };
}
exports.MsgWrappedStakingUpdateParams = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.msg !== undefined) {
            tx_1.MsgUpdateParams.encode(message.msg, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedStakingUpdateParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.msg = tx_1.MsgUpdateParams.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { msg: isSet(object.msg) ? tx_1.MsgUpdateParams.fromJSON(object.msg) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.msg !== undefined) {
            obj.msg = tx_1.MsgUpdateParams.toJSON(message.msg);
        }
        return obj;
    },
    create(base) {
        return exports.MsgWrappedStakingUpdateParams.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgWrappedStakingUpdateParams();
        message.msg = (object.msg !== undefined && object.msg !== null)
            ? tx_1.MsgUpdateParams.fromPartial(object.msg)
            : undefined;
        return message;
    },
};
function createBaseMsgWrappedStakingUpdateParamsResponse() {
    return {};
}
exports.MsgWrappedStakingUpdateParamsResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWrappedStakingUpdateParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.MsgWrappedStakingUpdateParamsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseMsgWrappedStakingUpdateParamsResponse();
        return message;
    },
};
function createBaseMsgUpdateParams() {
    return { authority: "", params: undefined };
}
exports.MsgUpdateParams = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.authority = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            authority: isSet(object.authority) ? globalThis.String(object.authority) : "",
            params: isSet(object.params) ? params_1.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.authority !== "") {
            obj.authority = message.authority;
        }
        if (message.params !== undefined) {
            obj.params = params_1.Params.toJSON(message.params);
        }
        return obj;
    },
    create(base) {
        return exports.MsgUpdateParams.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = (object.params !== undefined && object.params !== null)
            ? params_1.Params.fromPartial(object.params)
            : undefined;
        return message;
    },
};
function createBaseMsgUpdateParamsResponse() {
    return {};
}
exports.MsgUpdateParamsResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.MsgUpdateParamsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateParamsResponse();
        return message;
    },
};
exports.MsgServiceName = "babylon.epoching.v1.Msg";
class MsgClientImpl {
    rpc;
    service;
    constructor(rpc, opts) {
        this.service = opts?.service || exports.MsgServiceName;
        this.rpc = rpc;
        this.WrappedDelegate = this.WrappedDelegate.bind(this);
        this.WrappedUndelegate = this.WrappedUndelegate.bind(this);
        this.WrappedBeginRedelegate = this.WrappedBeginRedelegate.bind(this);
        this.WrappedCancelUnbondingDelegation = this.WrappedCancelUnbondingDelegation.bind(this);
        this.WrappedEditValidator = this.WrappedEditValidator.bind(this);
        this.WrappedStakingUpdateParams = this.WrappedStakingUpdateParams.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    WrappedDelegate(request) {
        const data = exports.MsgWrappedDelegate.encode(request).finish();
        const promise = this.rpc.request(this.service, "WrappedDelegate", data);
        return promise.then((data) => exports.MsgWrappedDelegateResponse.decode(new wire_1.BinaryReader(data)));
    }
    WrappedUndelegate(request) {
        const data = exports.MsgWrappedUndelegate.encode(request).finish();
        const promise = this.rpc.request(this.service, "WrappedUndelegate", data);
        return promise.then((data) => exports.MsgWrappedUndelegateResponse.decode(new wire_1.BinaryReader(data)));
    }
    WrappedBeginRedelegate(request) {
        const data = exports.MsgWrappedBeginRedelegate.encode(request).finish();
        const promise = this.rpc.request(this.service, "WrappedBeginRedelegate", data);
        return promise.then((data) => exports.MsgWrappedBeginRedelegateResponse.decode(new wire_1.BinaryReader(data)));
    }
    WrappedCancelUnbondingDelegation(request) {
        const data = exports.MsgWrappedCancelUnbondingDelegation.encode(request).finish();
        const promise = this.rpc.request(this.service, "WrappedCancelUnbondingDelegation", data);
        return promise.then((data) => exports.MsgWrappedCancelUnbondingDelegationResponse.decode(new wire_1.BinaryReader(data)));
    }
    WrappedEditValidator(request) {
        const data = exports.MsgWrappedEditValidator.encode(request).finish();
        const promise = this.rpc.request(this.service, "WrappedEditValidator", data);
        return promise.then((data) => exports.MsgWrappedEditValidatorResponse.decode(new wire_1.BinaryReader(data)));
    }
    WrappedStakingUpdateParams(request) {
        const data = exports.MsgWrappedStakingUpdateParams.encode(request).finish();
        const promise = this.rpc.request(this.service, "WrappedStakingUpdateParams", data);
        return promise.then((data) => exports.MsgWrappedStakingUpdateParamsResponse.decode(new wire_1.BinaryReader(data)));
    }
    UpdateParams(request) {
        const data = exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateParams", data);
        return promise.then((data) => exports.MsgUpdateParamsResponse.decode(new wire_1.BinaryReader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map